import { emailDomains } from './domains';

export function getValidEmailDomains(): readonly string[] {
	return emailDomains;
}
